import { ColumnsType, ColumnType } from "antd/es/table";
import { format } from "date-fns";
import { TFunction } from "i18next";

import { formatMoney } from "~/shared/lib/formatMoney";
import { applySortToColumns } from "~/shared/ui/TableV2";

import { ILicensePositionGroupRow } from "./types";

export const POSITION_GROUP_SORTABLE_COLUMNS = [
  "organizationName",
  "employeeId",
  "employeeName",
  "position",
  "email",
  "tariffType",
  "licenseCost",
  "status",
  "lastLoginAt",
];

const COLUMN_WIDTHS: Record<string, number> = {
  organizationName: 160,
  employeeId: 116,
  employeeName: 140,
  position: 160,
  email: 140,
  tariffType: 100,
  licenseCost: 88,
  status: 110,
  lastLoginAt: 110,
};

const formatShortDate = (value?: Date) => {
  if (!value) {
    return "-";
  }

  try {
    return format(value, "dd.MM.yyyy");
  } catch {
    return "-";
  }
};

interface GetPositionGroupColumnsParams {
  t: TFunction;
  sortField?: string;
  sortType?: string;
  sortableColumns?: string[];
}

export const getPositionGroupColumns = ({
  t,
  sortField,
  sortType,
  sortableColumns,
}: GetPositionGroupColumnsParams): ColumnsType<ILicensePositionGroupRow> => {
  const columns = POSITION_GROUP_SORTABLE_COLUMNS.map(
    (option): ColumnType<ILicensePositionGroupRow> => {
      const baseColumn = {
        title: t(`licensePositionGroup.table.${option}`),
        dataIndex: option,
        key: option,
        width: COLUMN_WIDTHS[option],
      };

      if (option === "tariffType") {
        return {
          ...baseColumn,
          render: (value?: string) =>
            value ? t(`licensePositionGroup.tariffTypes.${value}`) : "-",
        };
      }

      if (option === "status") {
        return {
          ...baseColumn,
          render: (value?: string) =>
            value ? t(`licensePositionGroup.statuses.${value}`) : "-",
        };
      }

      if (option === "licenseCost") {
        return {
          ...baseColumn,
          render: (value?: number) => formatMoney(value),
        };
      }

      if (option === "lastLoginAt") {
        return {
          ...baseColumn,
          render: (value?: Date) => formatShortDate(value),
        };
      }

      return {
        ...baseColumn,
        render: (value?: string) => value || "-",
      };
    },
  );

  return applySortToColumns(columns, sortField, sortType, sortableColumns);
};
